import { Component, OnInit, Input } from '@angular/core';
import { ServiceService } from '../../services/service.service';

@Component({
  selector: 'app-calendar-item-edit-related-services-individual',
  templateUrl: './calendar-item-edit-related-services-individual.component.html',
  styleUrls: ['./calendar-item-edit-related-services-individual.component.css']
})
export class CalendarItemEditRelatedServicesIndividualComponent implements OnInit {

  @Input() public serviceId: string;
  public serviceName: string;

  constructor(public serviceSvc: ServiceService) { }

  ngOnInit() {

    this.GetParentService(this.serviceId);

  }

  private GetParentService(serviceId: string) {

    this.serviceName = "";
      
      console.log("Getting Recurring Service", serviceId);
      var x = this.serviceSvc.getItem(serviceId).then(
        (data) => {  
          if (data != null) { 
            this.serviceName = data.Localized[0].Name;
          }
          //this.listsLoaded = true;
          console.log("Recurring service loaded", data);
        }
      ); 

  }
 
}
  